// extracted by mini-css-extract-plugin
export default {"interstitial_container":"p-","interstitial_img":"q-","interstitial_text_container":"r-","interstitial_text":"s-","interstitial_container_noPic":"t-"};
    if(module.hot) {
      // 1715091684927
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  